
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import MedewerkersTable from "@/components/medewerkers/MedewerkersTable";
import { MedewerkerResponse } from "@/integrations/supabase/medewerkerTypes";

interface MedewerkersContentProps {
  isLoading: boolean;
  medewerkers: MedewerkerResponse[];
  onEdit: (medewerker: MedewerkerResponse) => void;
  onDelete: (id: string) => void;
  canEdit?: boolean;
  canDelete?: boolean;
}

const MedewerkersContent = ({
  isLoading,
  medewerkers,
  onEdit,
  onDelete,
  canEdit = true,
  canDelete = true
}: MedewerkersContentProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Medewerkers beheren</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="text-center p-6">
            <p>Medewerkers laden...</p>
          </div>
        ) : (
          <MedewerkersTable 
            medewerkers={medewerkers} 
            onEdit={onEdit}
            onDelete={onDelete}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default MedewerkersContent;
